<template>
  <v-list-item>
    <v-snackbar
      v-model="alertError"
      bottom
      color="error"
      icon="mdi-alert"
      border="left"
      elevation="2"
      class="mb-2"
      timeout="6000"
    >
      Errore durante la modifica della contabile.
    </v-snackbar>
    <v-dialog v-model="dialogConfermaSaldato" max-width="500">
      <v-card>
        <v-card-title class="headline">Conferma</v-card-title>
        <v-card-text>
          <template v-if="contabile.tipo === 1 && saldato">
            Rimuovere tutte le coperture registrate su questo debito e tornare a "non pagato"?
          </template>
          <template v-else>Sei sicuro di voler cambiare lo stato di saldato?</template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="confermaSaldato">Sì</v-btn>
          <v-btn color="red darken-1" text @click="annullaSaldato">No</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-list-item-content @click="$refs.modifica_contabile.open()">
      <v-list-item-title>{{ cliente.nome }}</v-list-item-title>
      <v-list-item-subtitle>{{ dataFormatted }}</v-list-item-subtitle>
      <v-list-item-subtitle v-if="contabile.ddt"
        >DDT # {{ contabile.ddt }}</v-list-item-subtitle
      >
      <v-list-item-subtitle
        v-if="documentiCollegatiFattura.length || documentiCollegatiCredito.length"
        class="d-flex align-center"
      >
        <v-icon v-if="documentiCollegatiFattura.length" x-small color="purple darken-1" class="mr-1"
          >mdi-file-percent-outline</v-icon
        >
        <span v-if="documentiCollegatiFattura.length" class="mr-2">{{ tooltipDocumentiFattura }}</span>
        <v-icon v-if="documentiCollegatiCredito.length" x-small color="teal darken-1" class="mr-1"
          >mdi-cash-plus</v-icon
        >
        <span v-if="documentiCollegatiCredito.length">{{ tooltipDocumentiCredito }}</span>
      </v-list-item-subtitle>
      <v-list-item-subtitle v-if="contabile.id_ordine">
        <span
          >Ordine
          <ContabileOrdineRef
            readonly
            :id_ordine="contabile.id_ordine"
            ref="contabileOrdineRef" /></span
      ></v-list-item-subtitle>
      <v-list-item-subtitle
        v-if="contabile.residuo !== undefined"
        :class="residuoColorName + '--text'"
      >
        <v-icon x-small :color="residuoColorName" class="mr-1">{{ residuoIcon }}</v-icon>
        <template v-if="contabile.tipo === 1">
          <template v-if="contabile.importo_coperto !== undefined">
            acconto € {{ contabile.importo_coperto.toFixed(2) }}, da coprire € {{ contabile.residuo.toFixed(2) }}
          </template>
          <template v-else>da coprire € {{ contabile.residuo.toFixed(2) }}</template>
        </template>
        <template v-else>disponibile € {{ contabile.residuo.toFixed(2) }}</template>
      </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action-text>
      <span
        class="pa-1"
        :class="[
          contabile.tipo == 1
            ? contabile.verde
              ? 'green--text'
              : 'blue--text'
            : contabile.tipo == 2
            ? contabile.verde
              ? 'text-no-wrap green white--text'
              : 'text-no-wrap blue white--text'
            : 'purple--text',
          saldato ? 'text-decoration-line-through' : '',
        ]"
      >
        € {{ contabile.importo.toFixed(2) }}
      </span>
      <v-icon
        v-if="contabile.tipo === 1 && contabile.verde && documentiCollegatiFattura.length"
        x-small
        color="blue darken-1"
        class="ml-1"
        >mdi-swap-horizontal</v-icon
      >
    </v-list-item-action-text>
    <v-list-item-action>
      <v-checkbox
        v-if="contabile.tipo === 2"
        :input-value="true"
        readonly
        disabled
        dense
        hide-details
      ></v-checkbox>
      <div v-else-if="attesaFatturaBloccante" class="d-flex align-center">
        <v-checkbox
          :input-value="false"
          :indeterminate="true"
          readonly
          disabled
          dense
          hide-details
        ></v-checkbox>
        <v-icon small color="purple darken-1" class="ml-n1">mdi-timer-sand</v-icon>
        <v-list-item-subtitle class="text-caption purple--text ml-1">
          in attesa fattura{{ ddtAttesaFattura ? " DDT " + ddtAttesaFattura : "" }}
        </v-list-item-subtitle>
      </div>
      <v-menu
        v-else-if="contabile.tipo === 1 && !saldato"
        v-model="metodoMenuOpen"
        :close-on-content-click="false"
        offset-y
      >
        <template v-slot:activator="{ on }">
          <div class="d-flex align-center">
            <v-checkbox
              :input-value="false"
              :indeterminate="isPartial"
              readonly
              :loading="loadingSaldato"
              :disabled="loadingSaldato"
              dense
              hide-details
              v-on="on"
            ></v-checkbox>
            <v-icon v-if="contabile.in_attesa_fattura" small color="purple darken-1" class="ml-n1"
              >mdi-timer-sand</v-icon
            >
          </div>
        </template>
        <v-list dense>
          <v-subheader>Segna come pagato con...</v-subheader>
          <v-list-item
            v-for="m in metodiPagamento"
            :key="m.value"
            @click="registraPagamentoRapido(m.value)"
          >
            <v-list-item-title>{{ m.nome }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <div v-else-if="contabile.tipo === 3 && contabile.rate_pagamento" class="d-flex align-center">
        <v-checkbox
          :input-value="saldato"
          :indeterminate="!saldato"
          readonly
          disabled
          dense
          hide-details
        ></v-checkbox>
        <v-icon small color="purple darken-1" class="ml-n1">mdi-cash-multiple</v-icon>
        <v-list-item-subtitle class="text-caption purple--text ml-1">
          rate: € {{ contabile.rate_pagamento.incassato.toFixed(2) }} / € {{ contabile.rate_pagamento.totale.toFixed(2) }}
        </v-list-item-subtitle>
      </div>
      <div v-else-if="contabile.tipo === 3 && !saldato" class="d-flex align-center">
        <v-checkbox
          :input-value="false"
          readonly
          disabled
          dense
          hide-details
        ></v-checkbox>
        <v-icon small color="purple darken-1" class="ml-n1">mdi-file-percent-outline</v-icon>
        <v-list-item-subtitle class="text-caption purple--text ml-1">
          crea prima una rata dal dialog
        </v-list-item-subtitle>
      </div>
      <div v-else class="d-flex align-center">
        <v-checkbox
          v-model="saldato"
          readonly
          :loading="loadingSaldato"
          :disabled="loadingSaldato"
          dense
          hide-details
          @click="toggle_saldato(false)"
        ></v-checkbox>
      </div>
      <AllocazioneDialog :contabile="contabile" @cambiato="$emit('new_insert')" />
    </v-list-item-action>
    <modifica_contabile_mobile
      ref="modifica_contabile"
      :contabile="contabile"
      @update-contabile="$emit('new_insert')"
    />
  </v-list-item>
</template>

<script>
import contabile_element_mixin from "../mixin/contabile_element_mixin";
import modifica_contabile_mobile from "./modifica_contabile_mobile.vue";
import ContabileOrdineRef from "../desktop/contabile_ordine_ref.vue";
import AllocazioneDialog from "../desktop/allocazione_dialog.vue";
export default {
  components: {
    modifica_contabile_mobile,
    ContabileOrdineRef,
    AllocazioneDialog,
  },
  mixins: [contabile_element_mixin],
};
</script>